import { render, staticRenderFns } from "./PannelOne.vue?vue&type=template&id=51455981&scoped=true&"
import script from "./PannelOne.vue?vue&type=script&lang=js&"
export * from "./PannelOne.vue?vue&type=script&lang=js&"
import style0 from "./PannelOne.vue?vue&type=style&index=0&id=51455981&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51455981",
  null
  
)

export default component.exports